module.exports = __webpack_public_path__ + "images/emoji/top.5430addb0e79820fa5ec.png";